import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FormattedNumberInput } from '../util';
import YesOrNoFormField from '../util/form_fields/YesOrNoFormField';
import { CLAIM_GROUP_EDIT_FORM_FIELDS } from '@rd-web-markets/market/dist/constants';
const {
  showProjectMehotdology,
  showSicCodesString,
  showOverdueTaxesSection,
  showOverdueTaxesQuestion,
  showDoesCompanyReimburseStaffExpenses,
  showDoesCompanyPayCarAllowance,
  showClassificationForRndTaxPurposes
} = CLAIM_GROUP_EDIT_FORM_FIELDS;
export default function CompanyClaimGroupEditFormFieldGeneral(_ref) {
  let {
    claimGroup,
    onClaimGroupFieldChange,
    onRadioButtonChange,
    isUnderReview,
    questionnaires
  } = _ref;
  const showFirstNumber = () => {
    return process.env.PUBLIC_URL === '/us' || process.env.PUBLIC_URL === '/ca';
  };
  const showQuestionnaire = process.env.PUBLIC_URL !== '/de';
  const showStaffingCostType = process.env.PUBLIC_URL === '/uk';
  return /*#__PURE__*/React.createElement(React.Fragment, null, showClassificationForRndTaxPurposes && /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, "Classification For R&D Tax Purposes"), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    disabled: claimGroup.is_locked || isUnderReview,
    value: claimGroup.rnd_tax_purposes_classification,
    name: "rnd_tax_purposes_classification",
    onChange: onClaimGroupFieldChange,
    size: "md",
    type: "text"
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), /*#__PURE__*/React.createElement("option", {
    value: "small_medium_enterprise"
  }, "SME"), /*#__PURE__*/React.createElement("option", {
    value: "large_company"
  }, "Large company"), /*#__PURE__*/React.createElement("option", {
    value: "rnd_intensive_company"
  }, "R&D Intensive Company")))), showStaffingCostType && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, "Claim Type"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    disabled: claimGroup.is_locked || isUnderReview,
    value: claimGroup.rate_type,
    name: "rate_type",
    onChange: onClaimGroupFieldChange,
    size: "md",
    type: "text"
  }, /*#__PURE__*/React.createElement("option", {
    value: "sme"
  }, "SME"), /*#__PURE__*/React.createElement("option", {
    value: "rdec"
  }, "RDEC"), /*#__PURE__*/React.createElement("option", {
    value: "sme_and_rdec"
  }, "Both SME & RDEC"), /*#__PURE__*/React.createElement("option", {
    value: "merge_type"
  }, "Merge"), /*#__PURE__*/React.createElement("option", {
    value: "eris"
  }, "ERIS")))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, "Staffing Cost Type"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    disabled: claimGroup.is_locked || isUnderReview,
    value: claimGroup.staffing_cost_type,
    name: "staffing_cost_type",
    onChange: onClaimGroupFieldChange,
    size: "md",
    type: "text"
  }, /*#__PURE__*/React.createElement("option", {
    value: "rapid"
  }, "Rapid"), /*#__PURE__*/React.createElement("option", {
    value: "regular"
  }, "Regular"), /*#__PURE__*/React.createElement("option", {
    value: "realtime"
  }, "Realtime"))))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, showProjectMehotdology && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, "Project Methodology"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    disabled: claimGroup.is_locked || isUnderReview,
    value: claimGroup.project_methodology,
    name: "project_methodology",
    onChange: onClaimGroupFieldChange,
    size: "md",
    type: "text"
  }, /*#__PURE__*/React.createElement("option", {
    value: "employee_basis"
  }, "Employee Basis"), /*#__PURE__*/React.createElement("option", {
    value: "project_basis"
  }, "Project Basis"))))), showQuestionnaire && /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, "Questionnaire"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    disabled: isUnderReview,
    value: claimGroup.questionnaire_id || '',
    name: "questionnaire_id",
    onChange: onClaimGroupFieldChange,
    size: "md",
    type: "text"
  }, /*#__PURE__*/React.createElement("option", {
    value: '',
    disabled: true
  }, "Choose questionnaire"), questionnaires?.map(q => {
    return /*#__PURE__*/React.createElement("option", {
      value: q.id,
      key: q.id
    }, q.name);
  })))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, showSicCodesString && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, "SIC code"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    disabled: claimGroup.is_locked || isUnderReview,
    onChange: onClaimGroupFieldChange,
    name: "sic_codes",
    value: claimGroup.sic_codes || '',
    size: "md",
    type: "text"
  })))), showOverdueTaxesSection && /*#__PURE__*/React.createElement(React.Fragment, null, showOverdueTaxesQuestion && /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Does the company currently have any overdue taxes (Corporation Tax, PAYE or VAT)?",
    formName: "has_overdue_taxes",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.has_overdue_taxes,
    onChange: onRadioButtonChange
  }), claimGroup.has_overdue_taxes && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "Please provide amounts"), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: {
      span: 2,
      offset: 1
    }
  }, "- Corporation Tax"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(FormattedNumberInput, {
    customInput: Form.Control,
    value: claimGroup.corporation_tax_overdue || '',
    name: "corporation_tax_overdue",
    disabled: claimGroup.is_locked || isUnderReview,
    onChange: onClaimGroupFieldChange,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: {
      span: 2,
      offset: 1
    }
  }, "- Paye"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(FormattedNumberInput, {
    disabled: claimGroup.is_locked || isUnderReview,
    customInput: Form.Control,
    value: claimGroup.paye_overdue || '',
    name: "paye_overdue",
    onChange: onClaimGroupFieldChange,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: {
      span: 2,
      offset: 1
    }
  }, "- VAT"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(FormattedNumberInput, {
    disabled: claimGroup.is_locked || isUnderReview,
    customInput: Form.Control,
    value: claimGroup.vat_overdue || '',
    name: "vat_overdue",
    onChange: onClaimGroupFieldChange,
    size: "md",
    type: "text"
  })))), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Are any staff involved in R&D projects who are not on the company's payroll?",
    formName: "has_staff_involved_not_on_payroll",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.has_staff_involved_not_on_payroll,
    onChange: onRadioButtonChange
  }), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Have accounts been provided to Ayming?",
    formName: "accounts_provided",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.accounts_provided,
    onChange: onRadioButtonChange
  }), claimGroup.accounts_provided === false && /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: {
      span: 6,
      offset: 1
    }
  }, "Expected Date"), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(DatePicker, {
    disabled: isUnderReview,
    selected: claimGroup.accounts_provided_date,
    onChange: date => onClaimGroupFieldChange({
      target: {
        name: 'accounts_provided_date',
        value: date
      }
    })
  }))), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Have tax computations been provided to Ayming?",
    formName: "tax_computations_provided",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.tax_computations_provided,
    onChange: onRadioButtonChange
  }), claimGroup.tax_computations_provided === false && /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: {
      span: 6,
      offset: 1
    }
  }, "Expected Date"), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(DatePicker, {
    disabled: claimGroup.is_locked || isUnderReview,
    selected: claimGroup.tax_computations_provided_date,
    onChange: date => onClaimGroupFieldChange({
      target: {
        name: 'tax_computations_provided_date',
        value: date
      }
    })
  }))), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Have any development costs been capitalised?",
    formName: "development_costs_capitalised",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.development_costs_capitalised,
    onChange: onRadioButtonChange
  }), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Has the company been contracted to carry out R&D by any third party?",
    formName: "contracted_by_third_party",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.contracted_by_third_party,
    onChange: onRadioButtonChange
  }), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Has the company received any grants or subsidies towards its R&D activities?",
    formName: "received_grants_or_subsidies",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.received_grants_or_subsidies,
    onChange: onRadioButtonChange
  }), claimGroup.received_grants_or_subsidies && /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: {
      span: 6,
      offset: 1
    }
  }, "Please provide brief details"), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(Form.Control, {
    disabled: claimGroup.is_locked || isUnderReview,
    value: claimGroup.received_grants_or_subsidies_details || '',
    name: "received_grants_or_subsidies_details",
    onChange: onClaimGroupFieldChange,
    size: "md",
    type: "text"
  }))), showDoesCompanyReimburseStaffExpenses && /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Does the company reimburse staff expenses?",
    formName: "reimburses_staff_expenses",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.reimburses_staff_expenses,
    onChange: onRadioButtonChange
  }), showDoesCompanyPayCarAllowance && /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Does the company pay car allowance to those that have been involved in R&D?",
    formName: "purchased_company_cars",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.purchased_company_cars,
    onChange: onRadioButtonChange
  }), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Are any patents registered in the company's name?",
    formName: "has_patents",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.has_patents,
    onChange: onRadioButtonChange
  }), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Is the business registered in northern Ireland?",
    formName: "is_business_registered_in_northern_ireland",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.is_business_registered_in_northern_ireland,
    onChange: onRadioButtonChange
  }), claimGroup.hasOwnProperty('earliest_sol_filing_deadline') &&
  /*#__PURE__*/
  // which means US specific
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md"
  }, "Earliest SOL / Filing Deadline"), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(DatePicker, {
    disabled: claimGroup.is_locked || isUnderReview,
    selected: claimGroup.earliest_sol_filing_deadline,
    onChange: date => onClaimGroupFieldChange({
      target: {
        name: 'earliest_sol_filing_deadline',
        value: date
      }
    })
  }))), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Extended:",
    formName: "extended",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.extended,
    onChange: onRadioButtonChange
  }), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Credits Available / Received:",
    formName: "credits_available_received",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.credits_available_received,
    onChange: onRadioButtonChange
  }), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "IDR Received Interviews:",
    formName: "idr_received_interviews",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.idr_received_interviews,
    onChange: onRadioButtonChange
  }), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Contracts / Docs Received:",
    formName: "contracts_docs_received",
    disabled: claimGroup.is_locked || isUnderReview,
    checkedField: claimGroup.contracts_docs_received,
    onChange: onRadioButtonChange
  })), /*#__PURE__*/React.createElement("hr", {
    className: "line-solid-full"
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, showFirstNumber() && '1.', " Client website / specific web page for background information."), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(Form.Control, {
    disabled: claimGroup.is_locked || isUnderReview,
    onChange: onClaimGroupFieldChange,
    name: "website",
    value: claimGroup.website || '',
    size: "md",
    type: "text"
  }))), process.env.PUBLIC_URL !== '/uk' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, "2. Contact Name to collaborate on R&D technical narrative."), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(Form.Control, {
    disabled: claimGroup.is_locked || isUnderReview,
    onChange: onClaimGroupFieldChange,
    name: "technical_contact_name",
    value: claimGroup.technical_contact_name || '',
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, "3. Name(s) of key technical personnel Job Title(s)"), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(Form.Control, {
    disabled: claimGroup.is_locked || isUnderReview,
    onChange: onClaimGroupFieldChange,
    name: "job_title_of_technical_personnel",
    value: claimGroup.job_title_of_technical_personnel || '',
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, "4. Qualifications of technical personnel e.g. degrees, Masters, PhDs, Chartership etc."), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(Form.Control, {
    disabled: claimGroup.is_locked || isUnderReview,
    onChange: onClaimGroupFieldChange,
    as: "textarea",
    rows: 2,
    name: "qualifications_of_technical_personnel",
    value: claimGroup.qualifications_of_technical_personnel || '',
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, "5. Relevant experience of key technical personnel e.g. years in relevant roles during their career."), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(Form.Control, {
    disabled: claimGroup.is_locked || isUnderReview,
    onChange: onClaimGroupFieldChange,
    name: "relevent_experience_of_key_technical_personnel",
    value: claimGroup.relevent_experience_of_key_technical_personnel || '',
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, "6. Contact's email."), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(Form.Control, {
    disabled: claimGroup.is_locked || isUnderReview,
    onChange: onClaimGroupFieldChange,
    name: "technical_contact_email",
    value: claimGroup.technical_contact_email || '',
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, "7. Contact's telephone number."), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(Form.Control, {
    disabled: claimGroup.is_locked || isUnderReview,
    onChange: onClaimGroupFieldChange,
    name: "technical_contact_phone",
    value: claimGroup.technical_contact_phone || '',
    size: "md",
    type: "text"
  }))))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 7
  }, process.env.PUBLIC_URL === '/us' && '8.', " Anything else to add."), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(Form.Control, {
    disabled: claimGroup.is_locked || isUnderReview,
    as: "textarea",
    rows: 5,
    onChange: onClaimGroupFieldChange,
    name: "internal_notes",
    value: claimGroup.internal_notes || '',
    size: "md",
    type: "text"
  }))));
}